/**
 * Whether a date field offers the cross that clears its date (HAM-3564). Only a field that must hold a date when the
 * form is saved keeps the cross away, and a field the user cannot change has nothing to clear either. Required is the
 * single source for that, so a form never repeats itself with a second prop.
 */
export type ClearableDateFieldState = {
    required?: boolean
    readOnly?: boolean
    disabled?: boolean
}

export function isDateFieldClearable(state: ClearableDateFieldState): boolean {
    return !(state.required || state.readOnly || state.disabled)
}
